import { cn } from '@/utils';
import { Tooltip } from '@analytical-alley/ui';
import { IconBan, IconCircleCheck } from '@tabler/icons-react';
import { Control, Controller } from 'react-hook-form';
import { BudgetRowValues } from './ModifyBudgetRow';

interface Props {
    name: string;
    control: Control<BudgetRowValues>;
    isExcluded: boolean;
    disabled?: boolean;
    onExclude: () => void;
    onInclude: () => void;
}

const EXCLUDED_TOOLTIP =
    'This media variable is excluded from the optimization.';
const INCLUDED_TOOLTIP =
    'Exclude this media variable from the optimization.';

export const DisableToggle = ({
    name,
    control,
    isExcluded,
    disabled = false,
    onExclude,
    onInclude,
}: Props) => {
    return (
        <Controller
            control={control}
            name="excluded"
            render={({ field: { onChange, value } }) => (
                <Tooltip placement="top">
                    <Tooltip.Trigger asChild>
                        <button
                            type="button"
                            id={`disable-toggle-${name}`}
                            disabled={disabled}
                            className={cn(
                                'self-center cursor-pointer text-white',
                                {
                                    'opacity-50 cursor-not-allowed': disabled,
                                },
                            )}
                            onClick={() => {
                                const next = !value;
                                onChange(next);
                                if (next) {
                                    onExclude();
                                } else {
                                    onInclude();
                                }
                            }}
                        >
                            {isExcluded ? (
                                <IconBan size={20} />
                            ) : (
                                <IconCircleCheck size={20} />
                            )}
                        </button>
                    </Tooltip.Trigger>
                    <Tooltip.Content className="tooltip-content">
                        {isExcluded ? EXCLUDED_TOOLTIP : INCLUDED_TOOLTIP}
                    </Tooltip.Content>
                </Tooltip>
            )}
        />
    );
};
